import { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useCloseTab } from '../../components/tabs/TabsContext';
import { useApiProgress } from '../../hooks/ApiProgress';
import { toast } from 'react-toastify';
import { ENTITY_IS_IN_USE_MESSAGE, PRODUCT_TYPES, VALIDATION_MESSAGE } from '../../utils/constants';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { formatNumber, formatNumber4Digits, onChange } from '../../utils/functions';
import Textarea from '../../components/Textarea';
import { PRODUCT_PATH, getPageProducts } from '../../api/productApi';
import useFirstRender from '../../hooks/FirstRender';
import { Combobox, Dialog, Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { FaPlus } from 'react-icons/fa';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { SUPPLIER_PATH, getPageSuppliers, getSupplierById } from '../../api/supplierApi';
import { LOCATION_PATH, getPageLocations } from '../../api/locationApi';
import { getPurchaseById, updatePurchase } from '../../api/purchaseApi';
import { addRollByPurchase, deleteRollByPurchase, getAllRolls, updateRollByPurchase } from '../../api/rollApi';
import { updatePurchaseAction } from '../../redux/feature/purchaseSlice';
import SupplierPicker from '../../components/supplier/SupplierPicker';
import ProductPicker from '../../components/product/ProductPicker';
import LocationPicker from '../../components/location/LocationPicker';
import ProductLabel from '../../components/product/ProductLabel';

const PurchaseEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const isFirstRender = useFirstRender()
    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [errors, setErrors] = useState({})
    const [rolls, setRolls] = useState([])
    const [purchase, setPurchase] = useState({})
    const [updateRoll, setUpdateRoll] = useState({
        product: undefined,
        location: undefined,
        boilerCode: "",
        quantity: "",
        unitPrice: "",
        unitCost: "",
        parity: ""
    })
    const [newRoll, setNewRoll] = useState({
        product: undefined,
        location: undefined,
        boilerCode: "",
        quantity: "",
        unitPrice: "",
        parity: ""
    })

    const [supplierPage, setSupplierPage] = useState({
        content: []
    });
    const [productPage, setProductPage] = useState({
        content: []
    });
    const [locationPage, setLocationPage] = useState({
        content: []
    });

    const [supplierQuery, setSupplierQuery] = useState('')
    const [productQuery, setProductQuery] = useState('')
    const [locationQuery, setLocationQuery] = useState('')

    const [searchTimerSupplier, setSearchTimerSupplier] = useState();
    const [searchTimerProduct, setSearchTimerProduct] = useState();
    const [searchTimerLocation, setSearchTimerLocation] = useState();

    const pendingApiCallSupplier = useApiProgress('get', `${SUPPLIER_PATH}/page`, false)
    const pendingApiCallProduct = useApiProgress('get', `${PRODUCT_PATH}/page`, false)
    const pendingApiCallLocation = useApiProgress('get', `${LOCATION_PATH}/page`, false)

    const [isOpenRollModal, setIsOpenRollModal] = useState(false)
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [deleteId, setDeleteId] = useState("")

    const searchingSupplier = async (params) => {
        if (searchTimerSupplier) clearTimeout(searchTimerSupplier);
        let timer = setTimeout(() => {
            getPageSuppliers(params)
                .then(res => {
                    setSupplierPage(res.data)
                })
        }, 500);
        setSearchTimerSupplier(timer);
    }

    const searchingProduct = async (params) => {
        if (searchTimerProduct) clearTimeout(searchTimerProduct);
        let timer = setTimeout(() => {
            getPageProducts(params)
                .then(res => {
                    setProductPage(res.data)
                })
        }, 500);
        setSearchTimerProduct(timer);
    }

    const searchingLocation = async (params) => {
        if (searchTimerLocation) clearTimeout(searchTimerLocation);
        let timer = setTimeout(() => {
            getPageLocations(params)
                .then(res => {
                    setLocationPage(res.data)
                })
        }, 500);
        setSearchTimerLocation(timer);
    }

    const onClickLoadMoreSupplier = () => {
        if (!supplierPage.last) {
            loadSuppliers({ search: supplierQuery, lastId: supplierPage.content[supplierPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMoreProduct = () => {
        if (!productPage.last) {
            loadProducts({ search: productQuery, lastId: productPage.content[productPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMoreLocation = () => {
        if (!locationPage.last) {
            loadLocations({ search: locationQuery, lastId: locationPage.content[locationPage.content.length - 1]?.id })
        }
    }

    const loadSuppliers = (params) => {
        !pendingApiCallSupplier &&
            getPageSuppliers(params)
                .then(res => {
                    setSupplierPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadProducts = (params) => {
        !pendingApiCallProduct &&
            getPageProducts(params)
                .then(res => {
                    setProductPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadLocations = (params) => {
        !pendingApiCallLocation &&
            getPageLocations(params)
                .then(res => {
                    setLocationPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingSupplier({ search: supplierQuery })
    }, [supplierQuery])

    useEffect(() => {
        !isFirstRender && searchingProduct({ search: productQuery })
    }, [productQuery])

    useEffect(() => {
        !isFirstRender && searchingLocation({ search: locationQuery })
    }, [locationQuery])



    useEffect(() => {
        getPurchaseById(id)
            .then(res => {
                setPurchase(res.data)
                getSupplierById(res.data.supplierId)
                    .then(res => {
                        setPurchase(prevState => ({ ...prevState, supplier: res.data }))
                    })
            })
            .then(() => {
                getAllRolls({ purchaseId: id })
                    .then(res => {
                        setRolls(res.data)
                    })
            })
        supplierPage.content.length === 0 && loadSuppliers({ size: 20 })
        productPage.content.length === 0 && loadProducts({ size: 20 })
        locationPage.content.length === 0 && loadLocations({ size: 20 })
    }, [id])

    const onClickEditRoll = (roll) => {
        setUpdateRoll(roll)
        setIsOpenRollModal(true)
    }

    const onClickDeleteRoll = (id) => {
        deleteRollByPurchase(id)
            .then(res => {
                setRolls(prevState => prevState.filter(r => r.id !== id))
                setDeleteId()
                toast.success('Ürün silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    const onSubmitEditRoll = () => {
        const body = {
            productId: updateRoll.product?.id,
            quantity: updateRoll.quantity,
            locationId: updateRoll.location?.id,
            boilerCode: updateRoll.boilerCode,
            unitPrice: updateRoll.unitPrice,
            unitCost: updateRoll.unitPrice / purchase.parity,
            purchaseId: purchase.id,
        }

        updateRollByPurchase(updateRoll.id, body)
            .then(res => {
                setRolls(prevState => prevState.map(r => {
                    if (r.id === res.data.id) return res.data
                    else return r
                }))
                setIsOpenRollModal(false)
                setUpdateRoll({})
                toast('Güncellendi')
            }).catch(err => {
                setRollErrors(err.response.data.validationErrors)
            })

    }

    const onClickAddNewRoll = () => {
        const body = {
            productId: newRoll.product?.id,
            quantity: newRoll.quantity,
            locationId: newRoll.location?.id,
            boilerCode: newRoll.boilerCode,
            unitPrice: newRoll.unitPrice,
            unitCost: newRoll.unitPrice / purchase.parity,
            purchaseId: id
        }
        addRollByPurchase(body)
            .then(res => {
                setRolls(prevState => ([...prevState, res.data]))
                toast.success('Kaydedildi')
            })
            .then(() => {
                getPurchaseById(id)
                    .then(res => {
                        dispatch(updatePurchaseAction(res.data))
                    })
            })
            .catch(err => {
                toast.error(VALIDATION_MESSAGE)
            })
    }

    const [rollErrors, setRollErrors] = useState({})

    const onSubmit = () => {
        const body = {
            purchaseDate: purchase.purchaseDate,
            parity: purchase.parity,
            invoiceNumber: purchase.invoiceNumber,
            vat: purchase.vat,
            supplierId: purchase.supplier?.id,
            currency: purchase.supplier?.currency,
            description: purchase.description,
        }
        updatePurchase(id, body)
            .then(res => {
                toast("Satın alım güncellendi")
                closeTab()
            }).catch(err => {

            })
    }

    useEffect(() => {
        setRolls(prevState => prevState.map((roll) => {
            return {
                ...roll,
                unitCost: roll.unitPrice / purchase.parity
            }
        }))
    }, [purchase.parity])

    return (
        <div>
            <div className='mb-5'>
                <label className='text-xl'>Satın Alım Düzenle</label>
            </div>
            <div className='grid grid-cols-12 gap-x-3'>
                {/* SUPPLIER PICKER */}
                <SupplierPicker
                    label='Tedarikçi'
                    pendingApiCall={pendingApiCallSupplier}
                    state={purchase.supplier}
                    setState={(value) => setPurchase(prevState => ({ ...prevState, supplier: value }))}
                    query={supplierQuery}
                    setQuery={setSupplierQuery}
                    error={errors.supplierId}
                    page={supplierPage}
                    setErrors={prevState => ({ ...prevState, supplierId: undefined })}
                    onClickClear={() => setPurchase(prevState => ({ ...prevState, supplier: undefined }))}
                    onClickLoadMore={() => onClickLoadMoreSupplier()}
                    disabled={purchase.charged}
                />
                <div className='col-span-2'>
                    <Input
                        name='purchaseDate'
                        label='Satın Alım Tarihi'
                        type='date'
                        value={purchase.purchaseDate}
                        error={errors?.purchaseDate}
                        onChange={e => onChange(e, setPurchase, setErrors)}
                        disabled={purchase.charged}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        name='invoiceNumber'
                        label='Fatura Numarası'
                        type='text'
                        value={purchase.invoiceNumber}
                        error={errors?.invoiceNumber}
                        onChange={e => onChange(e, setPurchase, setErrors)}
                        placeholder='Fatura numarası girin...'
                        disabled={purchase.charged}
                    />
                </div>
                <div className='col-span-1'>
                    <Input
                        name='vat'
                        label='Vergi (%)'
                        type='number'
                        value={purchase.vat}
                        error={errors?.vat}
                        onChange={e => onChange(e, setPurchase, setErrors)}
                        placeholder='Vergi'
                        disabled={purchase.charged}
                    />
                </div>
                <div className='col-span-1'>
                    <Input
                        name='parity'
                        label='Parite'
                        type='number'
                        error={errors?.parity}
                        value={purchase.parity}
                        onChange={e => onChange(e, setPurchase, setErrors)}
                        placeholder='Parite'
                        disabled={purchase.charged}
                    />
                </div>
                <div className='col-span-3'>
                    <Textarea
                        name='description'
                        label='Açıklama'
                        type='text'
                        value={purchase.description}
                        onChange={e => onChange(e, setPurchase, setErrors)}
                        placeholder='Açıklama girin'
                        disabled={purchase.charged}
                    />
                </div>

            </div>
            <table className='w-full text-left text-zinc-900 mb-3'>
                <thead className='text-xs uppercase tracking-wide sticky top-0 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/24'>#</th>
                        <th className='p-2 w-3/12'>Ürün</th>
                        <th className='p-2 w-2/12'>Lokasyon</th>
                        <th className='p-2 w-2/12 '>Kazan No</th>
                        <th className='p-2 w-1/12'>Metre</th>
                        <th className='p-2 w-1/24 normal-case'>{`BİRİM FİYAT ${purchase.supplier ? `(${purchase.supplier.currency}/m)` : ""}`}</th>
                        <th className='p-2 w-1/12 normal-case'>{`BİRİM MALİYET (USD/m)`}</th>
                        <th className='p-2 w-1/24'>Harcanan</th>
                        <th className='p-2 w-1/24'>Kalan</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        rolls.map((roll, index) => (
                            <tr key={index} className='border-b items-center text-sm'>
                                <td className='p-2'>
                                    <span className='text-xs'>#</span> {index}
                                </td>
                                <td className='p-2'>{<ProductLabel state={roll.product} />} </td>
                                <td className='p-2'>{roll.location?.name}</td>
                                <td className='p-2'>{roll.boilerCode}</td>
                                <td className='p-2'>{formatNumber(roll.quantity)}</td>
                                <td className='p-2'>{formatNumber(roll.unitPrice)} <span className='text-xs'>{purchase.supplier ? `${purchase.supplier?.currency}/m` : ""}</span> </td>
                                <td className='p-2'>{formatNumber4Digits(roll.unitCost)} <span className='text-xs'>USD/m</span></td>
                                <td className='p-2'>{roll.spentQuantity}</td>
                                <td className='p-2'>{roll.restQuantity}</td>
                                <td className='p-2 flex gap-x-3'>
                                    {
                                        !purchase.charged &&
                                        <>
                                            <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => onClickEditRoll(roll)}>
                                                <AiFillEdit />
                                            </span>
                                            <span
                                                className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                                onClick={() => {

                                                    onClickDeleteRoll(roll.id)
                                                }}
                                            >
                                                <AiFillDelete />
                                            </span>
                                        </>
                                    }

                                </td>
                            </tr>
                        ))
                    }
                    <tr className='text-sm' >
                        <td className='p-2'>TOPLAM</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className='p-2'>{formatNumber(rolls.reduce((a, c) => (a + Number(c.quantity)), 0))} m </td>
                        <td className='p-2'> {formatNumber(rolls.reduce((a, c) => a + Number(c.quantity * c.unitPrice), 0))} {purchase.supplier ? `${purchase.supplier?.currency}` : ""}</td>
                    </tr>
                    {
                        !purchase.charged &&
                        <tr>
                            <td>

                            </td>
                            <td>
                                {/* PRODUCT PICKER */}
                                <ProductPicker
                                    //label='Ürün'
                                    pendingApiCall={pendingApiCallProduct}
                                    state={newRoll.product}
                                    setState={(value) => setNewRoll(prevState => ({ ...prevState, product: value }))}
                                    query={productQuery}
                                    setQuery={setProductQuery}
                                    error={errors.productId}
                                    page={productPage}
                                    setErrors={() => setErrors(prevState => ({ ...prevState, productId: undefined }))}
                                    //onClickClear={() => setDetail(prevState => ({ ...prevState, product: undefined }))}
                                    onClickLoadMore={() => onClickLoadMoreProduct()}
                                />

                            </td>
                            <td>
                                {/* LOCATION PICKER */}
                                <LocationPicker
                                    //label='Ürün'
                                    pendingApiCall={pendingApiCallLocation}
                                    state={newRoll.location}
                                    setState={(value) => setNewRoll(prevState => ({ ...prevState, location: value }))}
                                    query={locationQuery}
                                    setQuery={setLocationQuery}
                                    error={errors.locationId}
                                    page={locationPage}
                                    setErrors={() => setErrors(prevState => ({ ...prevState, locationId: undefined }))}
                                    //onClickClear={() => setDetail(prevState => ({ ...prevState, product: undefined }))}
                                    onClickLoadMore={() => onClickLoadMoreLocation()}
                                />
                            </td>
                            <td>
                                <Input
                                    name="boilerCode"
                                    onChange={e => onChange(e, setNewRoll)}
                                    value={newRoll.boilerCode}
                                    placeholder='Kazan no girin...'
                                />
                            </td>
                            <td>
                                <Input
                                    type='number'
                                    name="quantity"
                                    onChange={e => onChange(e, setNewRoll)}
                                    placeholder='Metre...'
                                    value={newRoll.quantity}
                                />
                            </td>
                            <td>
                                <Input
                                    type='number'
                                    name="unitPrice"
                                    onChange={e => onChange(e, setNewRoll)}
                                    placeholder='Birim fiyat...'
                                    value={newRoll.unitPrice}
                                />
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                                <div className='flex gap-x-3 pl-5'>
                                    <FaPlus className='mb-3 cursor-pointer' onClick={onClickAddNewRoll} />
                                </div>
                            </td>
                        </tr>
                    }

                </tbody>
            </table>

            {
                !purchase.charged &&
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onSubmit}
                    />
                </div>
            }


            {/* ROLL UPDATE MODAL */}
            <Transition appear show={isOpenRollModal} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => setIsOpenRollModal(false)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900 mb-5"
                                    >
                                        Düzenle
                                    </Dialog.Title>
                                    <div>
                                        {/* PRODUCT PICKER */}
                                        <div className="w-full mb-3 col-span-3">
                                            <label>Ürün</label>
                                            <Combobox
                                                value={updateRoll.product ? `${updateRoll.product.collectionCode}${updateRoll.product.color ? `, ${updateRoll.product.color.code}` : ""}${updateRoll.product.weight ? `, ${updateRoll.product.weight.code}` : ""}${updateRoll.product.pattern ? `, ${updateRoll.product.pattern.code}` : ""}` : ""}
                                                onChange={(product) => { setUpdateRoll(prevState => ({ ...prevState, product })) }}
                                            >
                                                <div className="relative mt-1">
                                                    <div className="relative w-full cursor-default overflow-hidden rounded-md bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300">
                                                        <Combobox.Input
                                                            placeholder='Arama yapın...'
                                                            className="w-full border rounded-md py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 outline-none"
                                                            displayValue={updateRoll.product?.collectionCode}
                                                            onChange={(event) => setProductQuery(event.target.value)}
                                                        />
                                                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                                                            <ChevronUpDownIcon
                                                                className="h-5 w-5 text-gray-400"
                                                                aria-hidden="true"
                                                            />
                                                        </Combobox.Button>
                                                    </div>
                                                    <Transition
                                                        as={Fragment}
                                                        leave="transition ease-in duration-100"
                                                        leaveFrom="opacity-100"
                                                        leaveTo="opacity-0"
                                                        afterLeave={() => setProductQuery('')}
                                                    >
                                                        <Combobox.Options className="z-50 absolute mt-1 mb-2 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                                                            {productPage.content.length === 0 && productQuery !== '' ? (
                                                                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                                                                    Kayıt bulunamadı.
                                                                </div>
                                                            ) : (
                                                                productPage.content.map((product) => (
                                                                    <Combobox.Option
                                                                        key={product.id}
                                                                        className={({ active }) =>
                                                                            `relative cursor-default select-none ${active ? 'bg-teal-600 text-white' : 'text-gray-900'
                                                                            }`
                                                                        }
                                                                        value={product}
                                                                    >
                                                                        {({ selected, active }) => (
                                                                            <>
                                                                                <span
                                                                                    className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                                        }`}
                                                                                >
                                                                                    <div className='border p-2 text-xs'>
                                                                                        <label className='block'> Ürün Kodu : {product.collectionCode}</label>
                                                                                        <label className='block'> Ürün Adı : {product.collectionName}</label>
                                                                                        {product.color && <label className='block'> Renk Kodu : {product.color.code}</label>}
                                                                                        {product.weight && <label className='block'> Gramaj Kodu : {product.weight.code}</label>}
                                                                                        {product.pattern && <label className='block'> Desen Kodu : {product.pattern.code}</label>}
                                                                                    </div>

                                                                                </span>
                                                                                {selected ? (
                                                                                    <span
                                                                                        className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-teal-600'
                                                                                            }`}
                                                                                    >
                                                                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                                    </span>
                                                                                ) : null}
                                                                            </>
                                                                        )}
                                                                    </Combobox.Option>
                                                                ))
                                                            )}
                                                            {
                                                                !productPage.last &&
                                                                <Combobox.Option
                                                                    onClick={e => {
                                                                        onClickLoadMoreProduct()
                                                                        e.preventDefault()
                                                                    }}

                                                                    className={({ active }) =>
                                                                        `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-teal-600 text-white' : 'text-gray-900'
                                                                        }`
                                                                    }

                                                                >
                                                                    Daha fazla yükle
                                                                </Combobox.Option>
                                                            }
                                                        </Combobox.Options>
                                                    </Transition>
                                                </div>
                                            </Combobox>
                                        </div>
                                        {/* LOCATION PICKER */}
                                        <div className="w-full mb-3 col-span-3">
                                            <label>Lokasyon</label>
                                            <Combobox
                                                value={updateRoll.location ? updateRoll.location.name : ""}
                                                onChange={(location) => { setUpdateRoll(prevState => ({ ...prevState, location })) }}
                                            >
                                                <div className="relative mt-1">
                                                    <div className="relative w-full cursor-default overflow-hidden rounded-md bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300">
                                                        <Combobox.Input
                                                            placeholder='Arama yapın...'
                                                            className="w-full border rounded-md py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 outline-none"
                                                            displayValue={updateRoll.location?.name}
                                                            onChange={(event) => setLocationQuery(event.target.value)}
                                                        />
                                                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                                                            <ChevronUpDownIcon
                                                                className="h-5 w-5 text-gray-400"
                                                                aria-hidden="true"
                                                            />
                                                        </Combobox.Button>
                                                    </div>
                                                    <Transition
                                                        as={Fragment}
                                                        leave="transition ease-in duration-100"
                                                        leaveFrom="opacity-100"
                                                        leaveTo="opacity-0"
                                                        afterLeave={() => setLocationQuery('')}
                                                    >
                                                        <Combobox.Options className="z-50 absolute mt-1 mb-2 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                                                            {locationPage.content.length === 0 && locationQuery !== '' ? (
                                                                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                                                                    Kayıt bulunamadı.
                                                                </div>
                                                            ) : (
                                                                locationPage.content.map((location) => (
                                                                    <Combobox.Option
                                                                        key={location.id}
                                                                        className={({ active }) =>
                                                                            `relative cursor-default select-none ${active ? 'bg-teal-600 text-white' : 'text-gray-900'
                                                                            }`
                                                                        }
                                                                        value={location}
                                                                    >
                                                                        {({ selected, active }) => (
                                                                            <>
                                                                                <span
                                                                                    className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                                        }`}
                                                                                >
                                                                                    <div className='border p-2 text-xs'>
                                                                                        {location.name}
                                                                                    </div>

                                                                                </span>
                                                                                {selected ? (
                                                                                    <span
                                                                                        className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-teal-600'
                                                                                            }`}
                                                                                    >
                                                                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                                    </span>
                                                                                ) : null}
                                                                            </>
                                                                        )}
                                                                    </Combobox.Option>
                                                                ))
                                                            )}
                                                            {
                                                                !locationPage.last &&
                                                                <Combobox.Option
                                                                    onClick={e => {
                                                                        onClickLoadMoreLocation()
                                                                        e.preventDefault()
                                                                    }}

                                                                    className={({ active }) =>
                                                                        `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-teal-600 text-white' : 'text-gray-900'
                                                                        }`
                                                                    }

                                                                >
                                                                    Daha fazla yükle
                                                                </Combobox.Option>
                                                            }
                                                        </Combobox.Options>
                                                    </Transition>
                                                </div>
                                            </Combobox>
                                        </div>
                                        <Input
                                            name='boilerCode'
                                            label='Kazan No'
                                            type='text'
                                            error={rollErrors?.boilerCode}
                                            value={updateRoll.boilerCode}
                                            onChange={e => onChange(e, setUpdateRoll, setRollErrors)}
                                            placeholder='Kazan no'
                                        />
                                        <Input
                                            name='quantity'
                                            label='Metre (m)'
                                            type='number'
                                            error={rollErrors?.quantity}
                                            value={updateRoll.quantity}
                                            onChange={e => onChange(e, setUpdateRoll, setRollErrors)}
                                            placeholder='Metre'
                                        />
                                        <Input
                                            name='unitPrice'
                                            label={`Birim Fiyat (${purchase.supplier?.currency}/m)`}
                                            type='number'
                                            error={rollErrors?.unitPrice}
                                            value={updateRoll.unitPrice}
                                            onChange={e => onChange(e, setUpdateRoll, setRollErrors)}
                                            placeholder='Birim Fiyat'
                                        />
                                    </div>

                                    <div className="mt-4 flex justify-between">
                                        <button
                                            type="button"
                                            className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-emerald-100 px-4 py-2 text-sm font-medium text-emerald-900 hover:bg-emerald-200"
                                            onClick={onSubmitEditRoll}
                                        // disabled={pendingApiCall}
                                        >
                                            Kaydet
                                            {/* {pendingApiCall && <Spinner />} */}
                                        </button>
                                        <button
                                            type="button"
                                            className="outline-none inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200"
                                            onClick={() => setIsOpenRollModal(false)}
                                        >
                                            İptal
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    )
}

export default PurchaseEditPage